import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function SearchBar({ searchTerm, onSearchChange }) {
  const [active, setActive] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (active && inputRef.current) {
      inputRef.current.focus();
    }
  }, [active]);

  function handleSearchIconClick() {
    setActive(true);
  };

  function handleClearSearch() {
    onSearchChange("");
    setActive(false);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        transition: "all 0.3s ease",
      }}
    >
      {!active && (
        <div style={{ cursor: "pointer" }} onClick={handleSearchIconClick} aria-label="search icon" role="button">
          <FontAwesomeIcon icon="search" />
        </div>
      )}
      <input
        ref={inputRef}
        type="text"
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Search..."
        style={{
          marginLeft: active ? "0.5rem" : "0rem",
          width: active ? "200px" : "0px",
          transition: "width 0.7s ease",
          overflow: "hidden",
          border: active ? "1px solid #ccc" : "none",
          padding: active ? "0.25rem 0.5rem" : "0",
        }}
      />
      {active && (
        <div
          data-testid="clear-icon"
          style={{ cursor: "pointer", marginLeft: "0.5rem" }}
          onClick={handleClearSearch}
        >
          <FontAwesomeIcon icon="times" />
        </div>
      )}
    </div>
  );
}

export default SearchBar;
